module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-text-b9359f10.svg";